import { useState } from "react";
import { toAbsoluteUrl } from "../../../../_metronic/helpers";
import { Link, useNavigate, useParams } from "react-router-dom";

/**
 * AddBankDetail component displays information about bank mergers and IFSC code updates.
 * Shows a list of bank logos and navigation options for adding bank account details.
 */
const AddBankDetail = ({ login = null }) => {
  const { userId } = useParams();
  const navigate = useNavigate();
  const [redirectUrl] = useState(login ? 'customer' : 'customerCard')
  const [bankImages] = useState([{ image: './banks/ab.png' }, { image: './banks/allb.png' }, { image: './banks/corpb.png' }, { image: './banks/db.png' }, { image: './banks/dmb.png' }, { image: './banks/hdbd.png' },
  { image: './banks/jaipur.png' }, { image: './banks/lvb.png' }, { image: './banks/mysore.png' }, { image: './banks/obc.png' }, { image: './banks/patiala.png' }, { image: './banks/sb.png' },
  { image: './banks/travancore.png' }, { image: './banks/ubi.png' }, { image: './banks/vijayb.png' }])


  return (
    <>
      <div className="container mt-4">
        <div className="row">
          <div className="col-md-12">
            <p className="bank_message mb-8">
              Some banks have undergone mergers, resulting in changes to their IFSC codes.
              If your bank is listed below, please ensure you update the IFSC code before validating your bank details.
            </p>
            <div className="row">
              {bankImages &&
                bankImages.map((dataimage, index) => (

                  <div key={index} className="col-4 col-md-2">
                    <div style={{ border: '1px solid #c7baba' }} className=" p-2 mb-3 rounded">
                      <img
                        width="100%"
                        alt={`bank logo ${index}`}
                        src={toAbsoluteUrl(`/media/${dataimage.image}`)}
                      />
                    </div>
                  </div>
                ))}

            </div>
            <div className="mt-10 mb-5 d-flex justify-content-between">

              <button onClick={() => navigate(-1)} style={{ background: '#112845' }} className="btn  btn-lg w-150px text-white">Back</button>

              <Link to={`/${redirectUrl}/addbank-account/${userId}`}>
                <button className="btn btn-danger btn-lg btn-hover-success w-150px text-white">Next</button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddBankDetail;
